import { useNavigate } from 'react-router-dom';

import { PaymentCardSelector } from './components';
import { usePaymentTitle } from './hooks/usePaymentTitle';

import { NavBar } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import ROUTES from '@/router/routes';

export const PaymentCard = () => {
  const { isMobile } = useIsDesktop();
  const navigate = useNavigate();
  const title = usePaymentTitle();

  if (isMobile) {
    return (
      <NavBar
        desktop
        mobile={{
          leftContent: {
            backAction: () => {
              navigate(ROUTES.paymentMethodSelection, {
                replace: false,
              });
            },
          },
          centerContent: {
            title,
          },
        }}
      >
        <PaymentCardSelector className="p-6" />
      </NavBar>
    );
  }
  return null;
};
